import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import VisualizerBackground from '../components/VisualizerBackground';
import ScrollAnimation from '../components/ScrollAnimation';
import Metadata from '../components/Metadata';

const Success = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const formType = queryParams.get('form') || 'contact';
  
  // Redirect to home if accessed directly without form submission context
  useEffect(() => {
    // Add a class to mark the page as loaded (needed for Netlify forms)
    document.body.classList.add('form-success');
    
    // If page is reloaded (not coming from a form submission), redirect to home after 3 seconds
    const fromForm = sessionStorage.getItem('formSubmitted');
    if (!fromForm) {
      sessionStorage.setItem('formSubmitted', 'true');
    }
    
    return () => {
      // Clean up the session storage when unmounting
      sessionStorage.removeItem('formSubmitted');
    };
  }, [navigate]);
  
  // Customize message based on form type
  const getTitle = () => {
    switch (formType) {
      case 'testimonial':
        return 'Thank You for Your Feedback!';
      case 'contact':
      default:
        return 'Message Received!';
    }
  };
  
  const getMessage = () => {
    switch (formType) {
      case 'testimonial':
        return 'I appreciate you taking the time to share your experience. Your feedback is valuable and helps me improve my services.';
      case 'contact':
      default:
        return 'Thank you for reaching out. I will get back to you as soon as possible.';
    }
  };
  
  const getReturnLink = () => {
    switch (formType) {
      case 'testimonial':
        return '/testimonials';
      case 'contact':
      default:
        return '/';
    }
  };
  
  const getReturnText = () => {
    switch (formType) {
      case 'testimonial':
        return 'Back to Testimonials';
      case 'contact':
      default:
        return 'Back to Home';
    }
  };

  return (
    <div className="min-h-screen bg-drummer-dark text-white">
      <Metadata 
        title="Thank You | Daryian Kelton"
        description="Thank you for submitting your message."
        pageType="home"
      />
      <VisualizerBackground />
      
      <div className="container mx-auto px-4 pt-32 pb-16 min-h-[70vh] flex flex-col items-center justify-center">
        <div className="mb-8 animate-pulse">
          <img 
            src="/logo/DK Monogram Outline WH.svg" 
            alt="Daryian Kelton Logo" 
            className="h-32 md:h-40"
          />
        </div>
        
        <h1 className="text-3xl md:text-5xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-client-yellow via-client-yellow to-client-teal animate-gradient-x text-center">
          {getTitle()}
        </h1>
        
        <p className="text-xl text-white mb-10 max-w-xl text-center">
          {getMessage()}
        </p>
        
        <Link to={getReturnLink()} className="drum-button">
          {getReturnText()}
        </Link>
      </div>
    </div>
  );
};

export default Success; 